import { HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import tadpoleImage from "@/assets/tadpole.png";
import youngFrogImage from "@/assets/young-frog.png";
import frogImage from "@/assets/frog.png";

export const FrogEvolutionHelp = () => {
  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 rounded-full opacity-60 hover:opacity-100"
        >
          <HelpCircle className="h-4 w-4" />
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle className="flex items-center gap-2">
            <img src={frogImage} alt="Sapo" className="w-6 h-6 object-contain" /> Evolução do Sapo
          </DrawerTitle>
        </DrawerHeader>
        <div className="px-4 pb-8">
          <p className="text-sm text-muted-foreground mb-4">
            Complete seus hábitos consistentemente para evoluir seu sapo!
          </p>
          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-center gap-3 p-3 bg-muted/50 rounded-xl">
              <span className="text-3xl">🥚</span>
              <div>
                <p className="font-medium">Ovo</p>
                <p className="text-xs text-muted-foreground">0-3 dias</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-3 bg-muted/50 rounded-xl">
              <img src={tadpoleImage} alt="Girino" className="w-8 h-8 object-contain" />
              <div>
                <p className="font-medium">Girino</p>
                <p className="text-xs text-muted-foreground">4-10 dias</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-3 bg-muted/50 rounded-xl">
              <img src={youngFrogImage} alt="Jovem" className="w-8 h-8 object-contain" />
              <div>
                <p className="font-medium">Jovem</p>
                <p className="text-xs text-muted-foreground">11-30 dias</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-3 bg-muted/50 rounded-xl">
              <img src={frogImage} alt="Adulto" className="w-8 h-8 object-contain" />
              <div>
                <p className="font-medium">Adulto</p>
                <p className="text-xs text-muted-foreground">31+ dias</p>
              </div>
            </div>
          </div>
          <p className="text-xs text-muted-foreground mt-4 text-center">
            Sapos hibernam se você parar de completar o hábito 😴
          </p>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
